import clsx from 'clsx';
import { ButtonHTMLAttributes, MouseEvent, forwardRef } from 'react';

type InputButtonColor = 'primary' | 'success' | 'warning' | 'error';

interface InputButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'> {
    color?: InputButtonColor;
    onPress?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const colorClasses: Record<InputButtonColor, string> = {
    primary: 'tw-bg-primary',
    success: 'tw-bg-success',
    warning: 'tw-bg-warning',
    error: 'tw-bg-error'
};

const InputButton = forwardRef<HTMLButtonElement, InputButtonProps>(
    ({ className, color = 'success', onClick, onPress, children, type = 'button', ...rest }, ref) => {
        return (
            <button
                ref={ref}
                type={type}
                className={clsx(
                    'tw-mx-[10px] tw-flex tw-h-[20px] tw-w-fit tw-transform tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-border-0 tw-bg-transparent tw-p-0 tw-px-2 tw-text-white tw-transition tw-duration-200 tw-ease-in-out focus:tw-outline-none',
                    colorClasses[color],
                    className
                )}
                onClick={(event: MouseEvent<HTMLButtonElement>) => {
                    onPress?.(event);
                    onClick?.(event);
                }}
                {...rest}
            >
                {children}
            </button>
        );
    }
);

InputButton.displayName = 'InputButton';

export default InputButton;
